import { TypeClockInReports } from "../../../../../../views/reports/hr/attendance/@const";
import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportAttendance_Settings {

    // View settings
    public typeView     : TypeClockInReports
    public daterange    : DateRange
    public users        : ID[]
    public clockedInHour: boolean
    public requiredHours: boolean
    public workdays     : boolean
    public offDays      : boolean
    public colorCoding  : boolean

    constructor(data: any) {
        this.typeView      = _.get(data, "typeView", TypeClockInReports.DAILY)
        this.daterange     = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.users         = _.get(data, "users", [])
        this.clockedInHour = _.get(data, "clockedInHour", true)
        this.requiredHours = _.get(data, "requiredHours", true)
        this.workdays      = _.get(data, "workdays", false)
        this.offDays       = _.get(data, "offDays", false)
        this.colorCoding   = _.get(data, "colorCoding", false)
    }

    get reportTitle() {
        let title = ""

        title += formatDaterange(this.daterange)

        return title
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            typeView      : this.typeView,
            users         : this.users,
            clockedInHour : this.clockedInHour,
            requiredHours : this.requiredHours,
            workdays      : this.workdays,
            offDays       : this.offDays,
            colorCoding   : this.colorCoding
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
